// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610200645/js/" + chunkId + "." + {"44":"120e36e3","225":"601ddb27","481":"77904116","486":"7f0bc329","770":"a3cbb939"}[chunkId] + ".0.4591929695278183.chunk.js";
};